import { IContractorField } from '@store/types/commonTypes'
import { WithTranslation } from 'react-i18next'

export interface IContractorInfoProps extends WithTranslation {
  contractor: IContractorField | undefined
  /** Отключение вывода подсказки */
  disableInfo: boolean
}

export enum InfoFieldName {
  INN = 'inn',
  KPP = 'kpp',
  OGRN = 'ogrn'
}

export interface IContractorAddFieldsProps {
  contractor: IContractorField | undefined
  wrapperClasses?: string
  labelClasses?: string
  valueClasses?: string
}
